import { FunctionComponent, useState } from "react";
import desktopStyles from "./BreadcrumbDesktopItem.module.css";
import mobileStyles from "./BreadcrumbMobileItem.module.css";
import { LabelPairedChevronRightSmRegularIcon } from "@deriv/quill-icons";
import { useFocusHandling } from "../../hooks/useFocusHandling";

export type BreadcrumbType = {
  className?: string;
  label?: string;
  showFocusRing?: boolean;

  /** Variant props */
  variant?: "desktop" | "mobile";
  size?: "sm" | "md";
  state?: "default" | "selected";

  /** Event handlers */
  onClick?: () => void;
};

export const Breadcrumb: FunctionComponent<BreadcrumbType> = ({
  className = "",
  variant = "desktop",
  size = "sm",
  state = "default",
  label = "Label",
  showFocusRing = false,
  onClick,
}) => {
  const styles = variant === "desktop" ? desktopStyles : mobileStyles;
  const [focus, setFocus] = useState(showFocusRing);

  const containerClassName =
    variant === "desktop" ? styles.containerText : styles.containerLabel;

  const isClickable = state !== "selected" && onClick;
  const breadcrumbId = `quill-breadcrumb-${variant}-${size}-${state}`;

  const { handleFocus, handleBlur } = useFocusHandling({
    isDisabled: !isClickable,
    setHighlight: setFocus,
  });

  return (
    <div
      className={[styles.root, className].join(" ")}
      data-size={size}
      data-state={state}
      data-id={breadcrumbId}
    >
      <div className={containerClassName}>
        <div
          className={[
            styles.label,
            isClickable ? "quill-ui-next-pointer" : "",
          ].join(" ")}
          onClick={isClickable ? onClick : undefined}
          role={isClickable ? "button" : undefined}
          tabIndex={isClickable ? 0 : undefined}
          onFocus={handleFocus}
          onBlur={handleBlur}
        >
          {label}
        </div>
        {focus && <div className={styles.bgFocus} />}
      </div>
      <div className={`${styles.iconDivider} breadcrumb-icon`}>
        <LabelPairedChevronRightSmRegularIcon />
      </div>
    </div>
  );
};

export default Breadcrumb;
